import React from 'react';
import UserInfoSkeleton from '@signal/components/UserInfo/skeleton';
export default function UserInfoContainer() {
  return /*#__PURE__*/React.createElement(UserInfoSkeleton, {
    showLogout: true
  });
}